import { Box, Typography } from "@mui/material"

export function SummaryBadge({ label, count, color }) {
    return (
        <Box sx={{ textAlign: "center", minWidth: "28px" }}>
            <Typography sx={{ fontWeight: 700, fontSize: "14px", lineHeight: 1.1, color, mb: "2px" }}>
                {count ?? 0}
            </Typography>
            <Typography sx={{ fontSize: "9px", lineHeight: 1.2, color: "#4b5563" }}>{label}</Typography>
        </Box>
    )
}
